import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-redo",
  "use": "icon-redo-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-redo\"><path d=\"M16 27.8h8.2v-2H16c-5.6 0-10-4.4-10-10s4.4-10 10-10h8.2L22 8l1.4 1.4L28 4.8 23.2 0l-1.4 1.4 2.4 2.4H16c-6.6 0-12 5.4-12 12s5.4 12 12 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol